<template>
  <div :class="['status-badge-wrap', wrapClass]">
    <div
        class="status-badge"
        :style="{ backgroundColor: color }"
    >
      {{ status }}
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  periodFrom: { type: String, required: false }, // "YYYY.MM.DD" 형태
  periodTo:   { type: String, required: false },
  wrapClass:  { type: String, required: false, default: '' }, // 클래스명 prop 추가
})

/* 날짜 파싱 & 상태 계산 -------------------------- */
const parseDate = (str) => {
  const [y, m, d] = str.split('.').filter(Boolean).map(Number)
  return new Date(y, m - 1, d)
}

const getStatus = (from, to) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const start = parseDate(from)
  const end   = parseDate(to)

  if (today < start) return 'Upcoming'
  if (today > end)   return 'Past'
  return 'Ongoing'
}

const status = computed(() =>
    getStatus(props.periodFrom, props.periodTo)
)

/* 색상 매핑 ------------------------------------ */
const colorMap = {
  Upcoming: '#FF0042',
  Ongoing:  '#0900FF',
  Past:     '#878787',
}

const color = computed(() => colorMap[status.value])
</script>

<style scoped>
.status-badge-wrap {
  position: absolute;
  top: 10px;
  right: 12px;
}

.status-badge {
  width: clamp(45px, 8vw, 92px);
  height: clamp(15px, 4vw, 36px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(21, 20, 25, 0.6);
  font-family: 'Poppins';
  font-weight: 600;
  font-size: clamp(8px, 1.6vw, 14px);
  color: #fff;
}

.status-badge-wrap.detail {
  left: 36px;
  top: 0px;
}

.status-badge-wrap.detail .status-badge {
  width: 65px;
  height: 17px;
  font-weight: 600;
  font-size: 11px;
}

@media (max-width: 460px) {
  .status-badge-wrap { top: 6px; right: 5px; }
  .status-badge      { border-radius: 3px; letter-spacing: -0.05em; }
}



</style>
